import { render, staticRenderFns } from "./ActiveItem.vue?vue&type=template&id=64aba3e2&"
import script from "./ActiveItem.vue?vue&type=script&lang=js&"
export * from "./ActiveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports